import { useListEntityApi } from '@/common/api/listEntityApi';
import type { MappingProfile } from 'shared/products/mapping/domain/mappingProfile';

export interface ListMappingProfilesResponse {
  ok: true;
  mappingProfiles: MappingProfile[];
}

export function useListMappingProfiles() {
  return useListEntityApi<ListMappingProfilesResponse>({
    url: 'mappingProfile',
    translate: (t) => t.products.actions.fetchMany,
    async processOk(response) {
      const json = await response.json() as MappingProfile[];

      json.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));

      return {
        ok: true,
        mappingProfiles: json,
      };
    },
  });
}
